// @flow

import axios from 'axios'
import Cookies from "js-cookie";
import { refreshToken } from "./API"
import { appConfig } from '../config';
/*
  window.location.origin polyfill
 */


export const getLocationOrigin = () => {
  if (!window.location.origin) {
    window.location.origin = `${window.location.protocol}//${
      window.location.hostname
    }${window.location.port ? ':' + window.location.port : ''}`;
  }
  return window.location.origin;
};

let cookie=Cookies.get('token', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' }) 
let token=''
let refreshtoken=''
if (cookie) token=Cookies.get('token', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
if (cookie) refreshtoken=Cookies.get('refreshtoken', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
/*
  query options:
 */
export const defaultOptions = {
  credentials: 'same-origin',
};

export const postMethod = {
  method: 'POST',
};
export const postFormMethod = {
  method: 'POST',
  headers: {
    'Content-Type': 'image/jpeg'
  },
};

export const getMethod = {
  method: 'GET',
};
export const loginHeader = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
};
export const imageHeader = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'image/jpeg'
  },
};
export const refreshAuthLogic = async failedRequest => {
  
  const url = `${appConfig.BASE_API}/refreshtoken`;
  console.log('refresh request',url)
      try{ 
          let param={
              token: this.token, refreshtoken: this.refreshtoken
            }
            // console.log('refresh token param',param)
          let response = await refreshToken({
              token: this.token, refreshtoken: this.refreshtoken
            });
           console.log('refresh token response',response)
          if (response){      
            if (response==403 || response==401){
              Cookies.remove('token', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
              Cookies.remove('refreshtoken', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
              sessionStorage.clear()
              localStorage.clear()            
              return null;
            }
            token=response.token;
            refreshtoken=response.refreshtoken;
            cookie.token=token;
            cookie.refreshtoken=refreshtoken;
          } 
          cookie.refreshStatus="idle";
          // console.log('idle')
          Cookies.set('token', token, { path: '/',domain: appConfig.DOMAIN, expires:400, secure: true, sameSite: 'strict' });  
          Cookies.set('refreshtoken', refreshtoken, { path: '/',domain: appConfig.DOMAIN, expires:400, secure: true, sameSite: 'strict' });  
          return Promise.resolve();
        }
        catch(error){
          
          
        }
  
}
export const gettoken = ()=> {
  let cookie=Cookies.get('token', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
  // console.log('get token',cookie)
  return cookie
  }
export const getrefreshtoken = () => {
    let cookie=Cookies.get('refreshtoken', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' }) 
    // console.log('get refresh token',cookie)
    // if (!cookie) return null
    
    return cookie;
};
export const settoken = async (token) => {
  Cookies.set('token', token, { path: '/',domain: appConfig.DOMAIN, expires:400, secure: true, sameSite: 'strict' });  
  }
export const setrefreshtoken =  (token) => {
    Cookies.set('refreshtoken', token, { path: '/',domain: appConfig.DOMAIN, expires:400, secure: true, sameSite: 'strict' });    
};
export const getaccesstoken =  () => {
    Cookies.get('token', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })  
    
};
export const jsonHeaderAuth = () => {
  
  let header={headers : {
    Accept: 'application/json',
    'Content-Type' : 'application/json',
    'Authorization' :'Bearer '+ cookie
    
  }}
  return header;
};
export const imageHeaderAuth = () => {
  let cookie=Cookies.get('token', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
  let header={headers : {
    // 'Content-Type' : 'multipart/form-data',
    'Authorization' :'Bearer '+ cookie
  }}
  return header;
};
export const jsonHeader = (tok) => {
  let header={headers : {
    Accept: 'application/json',
    'Content-Type' : 'application/json',
    'Authorization' :'Bearer '+ tok
  }}
  return header;
};

/*
  query response helpers:
 */
export const checkStatus = (response: {
  status: number,
  statusText: string,
  body: any,
  ...any,
}) => {
  console.log('check status',response)
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  return Promise.reject(error);
};

export const parseJSON = (response: any): any => {
  try{
    let result= response.json();
    return result;
  }catch(error){
    console.log('error parse json',response.json())
    return response;
  }
};

axios.interceptors.request.use(
  config => {    
    
    const token = Cookies.get('token', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
    // console.log('interceptor work',config.url,token)
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // config.headers['Content-Type'] = 'application/json';
    return config
  },
  error => {
    console.log('request reject error')
    Promise.reject(error)
  }
)
axios.interceptors.response.use(
  response => {
    // console.log('interceptors response  :: ', response)
    return response
  },
  async function (error) {
    // debugger;
    const originalRequest = error.config
    //console.log('interceptors originalRequest.url :: ', originalRequest.url)
    // console.log('interceptor response error',error)
    if (
      error.response.status === 401 
      &&
      originalRequest.url === `${appConfig.BASE_API}/refreshtoken`
    ) {
      //console.log('401 && refreshtoken')
      Cookies.remove('token', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
      Cookies.remove('refreshtoken', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
      sessionStorage.clear()
      localStorage.clear()  
      this.props.router.push('/')
      return Promise.reject(error)
    }

    if (error.response.status === 401 && !originalRequest._retry && !originalRequest.url.toString().includes(appConfig.iSupport_URL) ) {
      // console.log('interceptor response error refreshing')
      originalRequest._retry = true
      let refreshtoken = Cookies.get('refreshtoken', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
      let token = Cookies.get('token', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
      // console.log('token',token,refreshtoken)
      let res=await refreshToken({
              token: token, refreshtoken: refreshtoken
            })
        
      console.log('refresh token result',res)
      if (res.status === 201 || res.status === 200) {
        let result=await res.data
        // console.log('refresh token body',result)
        token=result.token;
        refreshtoken=result.refreshtoken;
        Cookies.set('token', token, { path: '/',domain: appConfig.DOMAIN, expires:400, secure: true, sameSite: 'strict' });  
        Cookies.set('refreshtoken', refreshtoken, { path: '/',domain: appConfig.DOMAIN, expires:400, secure: true, sameSite: 'strict' }); 
        originalRequest.headers['Authorization'] =
          'Bearer ' + Cookies.get('token', { path: '/',domain: appConfig.DOMAIN, secure: true, sameSite: 'strict' })
          // console.log(originalRequest)
        return axios.request(originalRequest)
      
      }
        

    }
    // console.log('promise reject error')
    return Promise.reject(error)
  }
)